import React, { useRef } from 'react';
import {
  AppBar,
  Toolbar,
  Dialog,
  Typography,
  IconButton,
  DialogContent,
  DialogActions,
  useMediaQuery,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Actions, useDispatchProvider, useStateDialogTransaction } from '../utils/StateProvider';
import FormTransaction from '../forms/FormTransaction';

const DialogTransaction = () => {
  const portalRef = useRef(null);
  const stateDialogTransaction = useStateDialogTransaction();
  const dispatch = useDispatchProvider();
  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    dispatch && dispatch({ type: Actions.DialogTransaction, payload: false });
    dispatch &&
      dispatch({
        type: Actions.Forms,
        payload: {
          formTransaction: '',
        },
      });
  };

  return (
    <Dialog
      open={stateDialogTransaction}
      onClose={handleDialogClose}
      maxWidth={'sm'}
      fullWidth={true}
      fullScreen={useMediaQuery((theme) => theme.breakpoints.down('md'))}
    >
      <AppBar position={'sticky'}>
        <Toolbar>
          <IconButton
            autoFocus
            size="large"
            edge="start"
            color="inherit"
            aria-label="close"
            sx={{ mr: 2 }}
            onClick={handleDialogClose}
          >
            <Close />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          >
            Transaction Details
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent dividers={true}>
        <FormTransaction portalRef={portalRef} />
      </DialogContent>
      <DialogActions
        sx={{ paddingX: 3, paddingY: 2 }}
        ref={portalRef}
      ></DialogActions>
    </Dialog>
  );
};

export default DialogTransaction;
